import type { LucideIcon } from 'lucide-react'
import {
  BookOpen,
  Calendar,
  CheckSquare,
  ClipboardList,
  ClipboardCheck,
  FileCheck,
  FolderOpen,
  GraduationCap,
  Home,
  LayoutDashboard,
  MessageSquareText,
  SmilePlus,
  Target,
  Users,
} from 'lucide-react'

const base = '/ekool-teacher'

export interface NavItem {
  titleKey: string
  url: string
  icon: LucideIcon
}

export const teacherNav: NavItem[] = [
  { titleKey: 'ekoolTeacher.nav.home', url: `${base}/teacher/dashboard`, icon: Home },
  { titleKey: 'ekoolTeacher.nav.journal', url: `${base}/teacher/journal`, icon: BookOpen },
  { titleKey: 'ekoolTeacher.nav.calendar', url: `${base}/teacher/calendar`, icon: Calendar },
  { titleKey: 'ekoolTeacher.nav.reports', url: `${base}/teacher/reports`, icon: ClipboardList },
  { titleKey: 'ekoolTeacher.nav.materials', url: `${base}/teacher/materials`, icon: FolderOpen },
  { titleKey: 'ekoolTeacher.nav.formative', url: `${base}/teacher/formative`, icon: SmilePlus },
  { titleKey: 'ekoolTeacher.nav.outcomes', url: `${base}/teacher/outcomes`, icon: Target },
  { titleKey: 'ekoolTeacher.nav.courses', url: `${base}/teacher/courses`, icon: CheckSquare },
]

export const classTeacherNav: NavItem[] = [
  {
    titleKey: 'ekoolClassTeacher.nav.dashboard',
    url: `${base}/class/dashboard`,
    icon: LayoutDashboard,
  },
  { titleKey: 'ekoolClassTeacher.nav.calendar', url: `${base}/class/calendar`, icon: Calendar },
  {
    titleKey: 'ekoolClassTeacher.nav.attendance',
    url: `${base}/class/attendance`,
    icon: ClipboardCheck,
  },
  {
    titleKey: 'ekoolClassTeacher.nav.absenceNotes',
    url: `${base}/class/absence-notes`,
    icon: FileCheck,
  },
  { titleKey: 'ekoolClassTeacher.nav.grades', url: `${base}/class/grades`, icon: GraduationCap },
  { titleKey: 'ekoolClassTeacher.nav.notes', url: `${base}/class/notes`, icon: MessageSquareText },
  { titleKey: 'ekoolClassTeacher.nav.students', url: `${base}/class/students`, icon: Users },
]

/** @deprecated Use teacherNav instead */
export const navMain = teacherNav
